import { toast } from "sonner";

const base = "text-white font-medium";

export const notify = {
  success: (msg: string) =>
    toast.success(msg, { className: `${base}`, style: { background: "#65A30D" } }),

  error: (msg: string) =>
    toast.error(msg, { className: `${base}`, style: { background: "#D72134" } }),
};
